module.exports = __webpack_public_path__ + "assets/img/icon-sup-i-purple.svg";